<template>
	<div id="assistingAccouting"  class="public-content">
		<el-tabs 
			type="card" v-model="tabVal" 
			@tab-click="handleClick"
			@tab-remove="tabsRemove"
			addable @tab-add="handleTabsAdd">
			<div class="fr">
				<el-button class='minButton' size="small" @click="importDataClick" v-for='i in importButton' :key='i.id'
					v-if='importButton.length'
				>
					{{i.name}}
				</el-button>
				<el-button class='minButton' size="small" @click="addVouterWorld">添加</el-button>
			</div>
			<el-tab-pane 
			v-for="item,index in listLabel.fztypes"  :key="index"
			:label="item.name" :name="item.id" 
			:closable="!item.systemDefault">
			</el-tab-pane>
		</el-tabs>
		<!-- 公共table 样式 -->
		<div class="table-item-public" style="margin-top:20px">
			<el-table :data="tableData" border size="small" style="width: 100$;">
				<el-table-column prop="code" label="编码" align="center"></el-table-column>
				<el-table-column prop="name" label="名称" align="center"></el-table-column>
				<el-table-column prop="specifications" label="规格" align="center" v-if="tabValName=='存货'"></el-table-column>
				<el-table-column prop="unit" label="单位" align="center" v-if="tabValName=='存货'"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" @click="editorEditor(scope.row)">修改</el-button>
						<el-button type="text" @click="deleteDelete(scope.row)" style="color: red;">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 公共 page 样式 -->
		<div class="page-item-public">
			<el-pagination background small
			@size-change="pageSizeChange"  @current-change="pageIndexChange" @prev-click="pageIndexChange" @next-click="pageIndexChange"
			layout="total, prev, pager, next, sizes, jumper" :total="page.totall" :current-page="page.pageIndex" :page-size="page.pageSize">
			</el-pagination>
		</div>
		
		
		<!-- 弹窗框 -->
		<el-dialog 
			title="新增辅助核算类别"
			:visible.sync="dialog.modal" width="420px" :close-on-click-modal="false"
			@close = "cancel('diaFormData1')"
		>
			<div class="form-item-public">
				<el-form label-width="120px" :model="diaFormData1" ref="diaFormData1" :rules="diaFormDataRuler1">
					<el-form-item label="辅助核算类别:" required prop="name">
						<el-input v-model="diaFormData1.name" size="small" placeholder="请输入类别名称!"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="cancel('diaFormData1')">取消</el-button>
				<el-button size="small" class='minButton' @click="addAuxiAccountType('diaFormData1')">确定</el-button>
			</div>
		</el-dialog>
		
		<!-- 弹窗框 -->
		<el-dialog 
			:title="dialogTitle"
			:visible.sync="dialog.modal2" width="420px" :close-on-click-modal="false"
			@close = "cancel('diaFormData')"
			class='default-dialog'
		>
			<div class="form-item-public" v-loading="dialog.loading">
				<el-form label-width="70px" :model="diaFormData" ref="diaFormData" :rules="diaFormDataRuler">
					<el-form-item label="编码:" required prop="code">
						<el-input v-model="diaFormData.code" size="small" placeholder="请输入编码!"></el-input>
					</el-form-item>
					<el-form-item label="名称:" required prop="name">
						<el-input v-model="diaFormData.name" size="small" placeholder="请输入名称!"></el-input>
					</el-form-item>
					<el-form-item label="规格:" prop="specifications" v-show="tabValName == '存货' ">
						<el-input v-model="diaFormData.specifications" size="small" placeholder="请输入核算规格!"></el-input>
					</el-form-item>
					<el-form-item label="单位:" prop="unit"  v-show="tabValName == '存货' ">
						<el-input v-model="diaFormData.unit" size="small" placeholder="请输入类别单位!"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right" v-show="!dialog.loading">
				<el-button size="small" @click="cancel('diaFormData')">取消</el-button>
				<el-button size="small" class='minButton' @click="addAuxilAccount('diaFormData')">确定</el-button>
			</div>
		</el-dialog>

		<!-- 导入辅助核算 -->
		<el-dialog
			title="导入辅助核算" :visible.sync="importFilesAssistingAccout" width="400px" :close-on-click-modal="false" class='Accouting_dialog_import'>
			<div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
				<div class="fliesUplaod"  >
					<h4 class='color333'>下载模板</h4>
					<el-button type="text" class='handleDownload' @click='handleDownload_MB'>点击下载模板</el-button>
					<h4 class='color333'>导入辅助核算</h4>
					<div class="uploads">
						<el-upload
						  drag
						  action="https://jsonplaceholder.typicode.com/posts/"
						  :show-file-list='true'
						  :auto-upload="false"
						  :on-change="OnChange"
						  :on-remove="OnRemove"
						  :before-remove="beforeRemove"
						  :limit='handleLimit'
						  ref='upload'
						  >
						  <i class="el-icon-upload"></i>
						  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						  <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
						</el-upload>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		const gg = (rule, value, callback) => {
			if(this.tabValName == '存货'){
				if(value == ''){
					callback(new Error('规格必填!'));
				}else{
					callback();
				}
			}else{
				callback();
			}
		};
		const sl = (rule, value, callback) => {
			if(this.tabValName == '存货'){
				if(value == ''){
					callback(new Error('数量必填!'));
				}else{
					callback();
				}
			}else{
				callback();
			}
		};
		return {
			importButton:[],  // 导入
			importFilesAssistingAccout: false,  // 导入弹框
			fileList:[],  // 文件
			handleLimit: 1,        // 上传文件数
			isImportFilesLoading: false,  // 导入loading
			dialogTitle: '',
			tabVal:"",
			tabValName:'',
			edit:false,
			dialog:{
				modal:false,
				modal2:false,
				loading:true
			},
			page:{
				pageIndex:1,
				pageSize:10,
				totall:1,
			},
			tableData: [],
			listLabel:{
				fztypes:[]
			},
			diaFormData1:{
				name:''
			},
			diaFormDataRuler1:{
				name:[{required:true,message:'请输入辅助核算类别名称!'}]
			},
			diaFormData:{
				code:'',
				name:'',
				specifications:'',
				unit:''
			},
			diaFormDataRuler:{
				code:[{required:true,message:'编码必填!'}],
				name:[{required:true,message:'名字必填!'}],
				specifications:[{validator:gg,trigger:'blur'}],
				unit:[{validator:sl,trigger:'blur'}],	
			}
		}
	},
	created(){
		this.findAllOject();
		this.getImportButton();
	},
	methods:{
		// 获取导入按钮
		getImportButton() {
			let params={
				permissions:'import:auxiliary:accounting',
			}
			try {
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this.importButton = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},
		// 移出提示
		 beforeRemove(file, fileList) {
       		 return this.$confirm(`确定移除 ${ file.name }？`);
	      },
	      // 传入文件监听
	      OnChange(file,fileList){
	      	
	        this.fileList=fileList

	      },
	      // 移出操作
	      OnRemove(file,fileList){
	        this.fileList=fileList
	      },
		// 确认导入
		handleUploadAdd() {
			this.params = new FormData();
			// 导入验证
			if(this.fileList.length>1) {
				return this.$message.warning('只能从列表选择一个上传哟!')
			}
			if(!this.fileList.length) {
				return this.$message.warning('请选择上传文件!')
			}
			let fileOne = this.fileList[0];
			let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
			const extension = testmsg === 'xls'
			const extension2 = testmsg === 'xlsx'
			const isLt5M = fileOne.size / 1024 / 1024 < 5
			if(!extension && !extension2) {
				return this.$message({
					message: '上传文件只能是 xls、xlsx格式!',
					type: 'warning'
				});
			}
			if(!isLt5M) {
				return this.$message({
					message: '上传文件大小不能超过 5MB!',
					type: 'warning'
				});
			}

			 this.params.append('multipartFile',fileOne.raw);
			 this.params.append('cid',sessionStorage.getItem('cid'));
			 this.params.append('token',sessionStorage.getItem('token'));
			 try {
			 	const instance = this.$http.create({
			 		withCredentials: true
			 	})
			 	this.isImportFilesLoading = true;

			 	instance.post(this.$rootUrl + 'auxiliaryAccounting/importFileAuxiliaryAccounting', this.params).then(res=>{
			 		if(res && (res.data.code == 1 || res.data.code == 99)) {
			 			this.importFilesAssistingAccout = false;
			 			this.isImportFilesLoading = false;
			 			if(res.data.code == 1) {
			 				this.$message.success(res.data.msg)
			 			}else {
			 				this.$message.warning(res.data.msg)
			 			}
			 			
			 			this.fileList=[];
			 			this.$refs.upload.clearFiles();
			 			this.findAllOject();
			 			this.getData();
			 		}else {
			 			this.$message.error(res.data.msg)
			 			this.isImportFilesLoading = false;
			 			this.fileList=[];
			 			this.$refs.upload.clearFiles();
				        
			 		}
			 	})
			 }catch(e) {

			 }
		},
		// 下载模板
		handleDownload_MB() {

				let cid=sessionStorage.getItem('cid');

			  	let token=sessionStorage.getItem('token');

 				window.location.href = this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token+"&templateName=辅助核算模板.xls";
 			},
		// 导入辅助核算
		importDataClick() {
			this.importFilesAssistingAccout = true;
		},
		getData(){
			const _=this;
			_.$http.post('auxiliaryAccounting/list',{
				typeId:_.tabVal,
				pageNo:_.page.pageIndex,
				pageSize:_.page.pageSize,
			}).then(res=>{
				if(res && res.data.code == '1'){
					let msg = res.data.data;
					_.tableData = msg.list;
					_.page.totall = parseInt(msg.totalCount);
				}
			});
		},
		handleTabsAdd(){
			this.dialog.modal = true
		},
		handleClick(tab){
			this.page.pageIndex = 1;
			this.page.pageSize = 10;
			this.tabVal = tab.name;
			this.tabValName = tab.label;
			this.getData();
		},
		tabsRemove(val){
			const _=this;
			_.$confirm('此操作将永久删除该辅助核算类别吗','删除',{
				confirmButtonText:'确定删除',
				cancelButtonText:'取消',
				type:'warning'
			}).then(()=>{
				_.$http.post('auxiliaryAccounting/delAccounting',{
					typeId:val
				}).then((res)=>{
					if(res && res.data.code == '1'){
						_.$message({
							message:'删除成功!',
							type:'success'
						})
						this.findAllOject();
					}
				}).catch(()=>{
					
				});
			});
			
			
		},
		addVouterWorld(){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialogTitle = '新增辅助核算';
			_.dialog.modal2 = true;
			_.edit = true;
			_.diaFormData.contentId = '';
		},
		editorEditor(row){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialogTitle = '修改辅助核算';
			_.edit = false;
			_.dialog.modal2 = true;
			_.$nextTick(()=>{
				for(let i in _.diaFormData){
					_.diaFormData[i] = row[i];
				}
				_.diaFormData.contentId = row.id;
			});
		},
		deleteDelete(row){
			const _=this;
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.$confirm('确定要删除该条数据嘛?','提示',{
				confirmButtonText:'确定',
				cancelButtonText:'取消',
				type:'warning'
			}).then(()=>{
				_.$http.post('auxiliaryAccounting/delContent',{
					contentId:row.id,
					auxiliaryAccountingId:_.tabVal,
				}).then((res)=>{
					if(res && res.data.code == '1'){
						_.$message({
							message:'删除成功!',
							type:'success'
						});
						_.getData()
					}
				});
				
			})
		},
		//查询辅助类别
		findAllOject(){
			const _=this;
			let datas = {
			}
			_.$http.post('auxiliaryAccounting/allAccounting',datas).then((res)=>{
				_.dialog.loading = false;
				if(res && res.data.code == '1'){
					_.listLabel.fztypes = res.data.data;
					_.tabVal =  res.data.data[0].id;
					_.tabValName = res.data.data[0].name;
					_.getData();
				}
			})
		},//新增辅助核算
		addAuxilAccount(ref){
			const _=this;
			_.$refs[ref].validate((valid)=>{
				if(valid){
					_.dialog.loading = true;
					_.diaFormData.auxiliaryAccountingId=_.tabVal;
					_.$http.post('auxiliaryAccounting/addContent',_.diaFormData).then((res)=>{
						_.dialog.loading = false;
						if(res && res.data.code == '1'){
							_.$message({
								message:res.data.msg,
								type:'success'
							});
							_.cancel(ref);
							_.getData();
						}
					});
				}
			});
		},//添加辅助核算类别
		addAuxiAccountType(ref){
			const _=this;
			_.$refs[ref].validate((valid)=>{
				if(valid){
					_.dialog.loading = true;
					_.$http.post('auxiliaryAccounting/add',_.diaFormData1).then((res)=>{
						_.dialog.loading = false;
						if(res && res.data.code == '1'){
							_.$message({
								message:res.data.msg,
								type:'success'
							});
							_.dialog.modal = false;
							_.findAllOject();
						}
					});
				}
			});
		},
		//页码发送变化
		pageIndexChange(page){
			this.page.pageIndex = page;
			this.getData();
		},//页码条数发送变化
		pageSizeChange(page){
			this.page.pageSize = page;
			this.getData();
		},
		cancel(ref){
			this.dialog.modal = false;
			this.dialog.modal2 = false;
			this.$refs[ref].resetFields();
		}

	},
	mounted() {
		
	},
}
</script>

<style lang="less">
	#assistingAccouting{
		position: relative;
		.btnAdd{
			position: absolute;
			right:30px;
			top:30px;
			z-index: 1
		}
		.Accouting_dialog_import {
			.el-dialog {
				.el-dialog__header {
					padding: 17px 20px;
					border-bottom: 1px solid #E5E5E5;
					.el-dialog__title {
						color: #333;
						font-size: 14px;
						font-weight: 600;
					}

				}
				.el-dialog__body {
					    padding: 18px 20px;
				}
			}
			.fliesUplaod{
				.fliesUplaod_text {
					color: #EC681D;
					display: inline-block;
					margin-bottom: 20px;
				}
				.handleDownload {
					margin: 3px 0 18px 0;
				}
				.uploads{
					padding:15px 0px;
					.el-upload-dragger {
						width: 250px;
						height: 90px;
						.el-icon-upload {
							font-size: 35px;
							margin: 0;
							line-height: 45px;
						}
					}
				}

			}
			.dialog-footer {
					text-align: right;
				}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/assistingAccouting.vue